import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getUsers } from "./usersTableApi";

export const usersTableSlice = createSlice({
    name: 'users',
    initialState: {
        users: [],
        editor: null,
        performer: null
    },
    reducers: {

        setPerformer: (state, action) => {
            state.performer = action.payload
        },
        resetPerformer: (state) => {
            state.performer = null
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getUsers.fulfilled, (state, action) => {

            state.users = action.payload



            //let navigate = useNavigate();
            //navigate("/control", { replace: true });
        })
        builder.addCase(getUsers.pending, (state, action) => {
        })

        builder.addCase(getUsers.rejected, (state, action) => {
            let message = "Что-то пошло не так!"
            if (action.error.message== "Request failed with status code 401"){
                localStorage.clear()
                message = "Нужно авторизоваться!"
            }
            toast.error(message, {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });

        })




    }
})


export const { setPerformer, resetPerformer } = usersTableSlice.actions

export default usersTableSlice.reducer
